"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var uuidgen = require("uuid");
var UuidV4 = (function () {
    function UuidV4() {
        this.uuid = uuidgen.v4();
    }
    UuidV4.prototype.toJSON = function () {
        return this.uuid;
    };
    return UuidV4;
}());
exports.UuidV4 = UuidV4;
//# sourceMappingURL=UuidV4.js.map